import { BadgeSeverity } from '@common/dsfr-ui';
import { StepStatus } from '../types/enums/step-status.enum';

export const STEP_STATUS_STYLES: Record<StepStatus, StyleAttr> = {
  [StepStatus.NEXT]: {
    text: 'à venir',
    severity: BadgeSeverity.INFO,
  },
  [StepStatus.NEW]: {
    text: 'nouveau',
    severity: BadgeSeverity.INFO,
  },
  [StepStatus.PROGRESS]: {
    text: 'en cours',
    severity: BadgeSeverity.INFO,
  },
  [StepStatus.DONE]: {
    text: 'réalisé',
    severity: BadgeSeverity.SUCCESS,
  },
};

interface StyleAttr {
  text: string;
  severity: BadgeSeverity;
}